export default __webpack_public_path__ + "d8aa2742c2aaec5e9249dc25409dfc16.jpeg";